import React from 'react'
import '../assets/styles/programme.css'
import { Link } from 'react-router-dom'

function Programme() {
  return (
    <div className="programmeContainer">

        <h1>Le programme sanglant du week<span><Link to='/bravo'><span id='bravo' className="material-symbols-outlined">
redeem
</span></Link></span>end</h1>
        <div className="grilleContainer">
            <h1>VENDREDI 27</h1>
            
            <table className="table">
                <thead className="table">
                    <tr className="table">
                        <th>TITRE</th>
                        <th>HORAIRE</th>
                        <th>CINEMA</th>
                        <th>DUREE</th>
                        <th>COMP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Memory of Water</td>
                        <td>11H00</td>
                        <td>Espace Lac</td>
                        <td>1H40</td>
                        <td>Oui</td>
                    </tr>
                    <tr>
                        <td>En plein feu</td>
                        <td>15H00</td>
                        <td>Espace Lac</td>
                        <td>1H25</td>
                        <td>Non</td>
                    </tr>
                    <tr>
                        <td>La tour</td>
                        <td>18H30</td>
                        <td>Paradiso</td>
                        <td>1H29</td>
                        <td>Oui</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="grilleContainer">
            <h1>SAMEDI 28</h1>
            <table className="table">
                <thead>
                    <tr>
                        <th>TITRE</th>
                        <th>HORAIRE</th>
                        <th>CINEMA</th>
                        <th>DUREE</th>
                        <th>COMP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>Watcher</td>
                        <td>11H30</td>
                        <td>Casino</td>
                        <td>1H36</td>
                        <td>Oui</td>
                    </tr>
                    <tr>
                        <td>Compétition court-métrages</td>
                        <td>15H00</td>
                        <td>Espace Lac</td>
                        <td>1H27</td>
                        <td>Comp CM</td>
                    </tr>
                    <tr>
                        <td>Venus - hommage à Jaumé Balaguero</td>
                        <td>19H30</td>
                        <td>Espace Lac</td>
                        <td>1H40</td>
                        <td>Non</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div className="grilleContainer">
            <h1>DIMANCHE 29</h1>
            <table className="table">
                <thead>
                    <tr>
                        <th>TITRE</th>
                        <th>HORAIRE</th>
                        <th>CINEMA</th>
                        <th>DUREE</th>
                        <th>COMP</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>La montagne</td>
                        <td>11H00</td>
                        <td>Espace Lac</td>
                        <td>1H52</td>
                        <td>Oui</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <Link to='/accueil'><button style={{margin: "20px 0px", padding: "10px", width: "200px", backgroundColor:"red", border: "none", borderRadius: "10px"}}>RETOUR ACCUEIL</button></Link>
    </div>
  )
}

export default Programme